import React, { Dispatch, SetStateAction } from 'react';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import { PAYMENT_CONFIG, PaymentDeviceConfig } from 'state/paymentConfig/type';
import FormLabel from 'components/form-label';
import SimpleDeviceConfig from './simpleDeviceConfig';
import FullDeviceConfig from './fullDeviceConfig';

interface DeviceRowExpansionProps {
  row: PAYMENT_CONFIG.IGetPaymentDeviceLocation;
  deviceConfig: Record<string, string | null | undefined>;
  setDeviceConfig: Dispatch<
    SetStateAction<Record<string, string | null | undefined>>
  >;
  paymentConfiguration: PAYMENT_CONFIG.IProcessorConfigurationObj | undefined;
  posLocationList: PAYMENT_CONFIG.IPosLocation[] | undefined;
  onTestDevice: (deviceId: string, processorName: string) => void;
  showTestButton?: boolean;
}

const DeviceRowExpansion = ({
  row,
  deviceConfig,
  setDeviceConfig,
  paymentConfiguration,
  posLocationList,
  onTestDevice,
  showTestButton = true,
}: DeviceRowExpansionProps) => {
  return (
    <div className="w-full">
      <div className="mb-2 pl-1">
        <FormLabel
          element="device_name"
          label="Name of device"
          className="text-sm font-medium text-gray-blue-80 mb-1 mt-2 pl-3"
        />
        <Input
          name="device_name"
          id="device_name"
          className="w-80 mt-1 ml-3 bg-gray-blue-1"
          disabled
          defaultValue={row.name}
        />
      </div>
      <div className="mb-2 pl-1">
        <FormLabel
          element="pos_location"
          label="POS Location"
          className="text-sm font-medium text-gray-blue-80 mb-1 mt-2 pl-3"
        />
        <Select disabled value={row.posLocationId || row.locationId || ''}>
          <SelectTrigger id="pos_location" className="w-80 mt-1 ml-3 bg-gray-blue-1">
            <SelectValue placeholder="No location" />
          </SelectTrigger>
          <SelectContent>
            {posLocationList?.map((item) => (
              <SelectItem key={item.id} value={item.id}>
                {item.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {paymentConfiguration?.deviceConfigurationMode ===
        PaymentDeviceConfig.FULL && (
        <FullDeviceConfig
          deviceConfig={{
            registerId: row.deviceregisterid,
            printConfig: row?.printConfig,
            deviceAuthCode: row?.deviceauthcode,
            tpn: row?.tpn,
            posLocationId: row?.posLocationId,
            locationId: row?.locationId,
          }}
          inModal={false}
        />
      )}
      {paymentConfiguration?.deviceConfigurationMode ===
        PaymentDeviceConfig.SIMPLE && (
        <SimpleDeviceConfig
          disabled
          inModal={false}
          deviceConfig={{
            registerId: row.deviceregisterid,
            printConfig: row?.printConfig,
            deviceAuthCode: row?.deviceauthcode,
            posLocationId: row?.posLocationId,
            locationId: row?.locationId,
          }}
        />
      )}
      {showTestButton && (
        <span className="inline-flex ml-4">
          <Button
            data-testid="testDevice"
            variant="default"
            size="default"
            className="flex items-center justify-center m-0 mb-2 w-40"
            onClick={() => onTestDevice(row.id, row.processorName)}
          >
            Test
          </Button>
        </span>
      )}
    </div>
  );
};

export default DeviceRowExpansion;
